import { ref, uploadString, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '@api/Firebase/Firebase';

export default {
    async uploadFileToStorage(path: string, imageBase64: string, mimeType: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            try {
                const storageRef = ref(storage, path);
                const uploadTask = await uploadString(storageRef, imageBase64, 'base64', { contentType: mimeType });
                const url = await getDownloadURL(uploadTask.ref);
                resolve(url);
            } catch (error) {
                reject('Error uploading file: ' + error);
            }
        });
    },
    async removeImageFromStorage(photoSrc: string): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                const storageRef = ref(storage, photoSrc);
                await deleteObject(storageRef);
                resolve();
            } catch (error) {
                reject('Error removing photo: ' + error);
            }
        });
    },
    async getFileDownloadUrl(path: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            try {
                const storageRef = ref(storage, path);
                const url = await getDownloadURL(storageRef);
                resolve(url);
            } catch (error) {
                reject('Error getting download URL: ' + error);
            }
        });
    }
};
